<template>
    <div class="demo-card">
        <div class="demo-card-title-wrapper" v-if="!!title">
            <div class="demo-card-title">{{title}}</div>
            <link-segment/>
        </div>
        <div class="demo-card-content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "demo-row",
        props: {
            title: {type: String, default: null}
        }
    }
</script>

<style lang="scss">
    .demo-card {
        .demo-card-title-wrapper {
            display: flex;
            width: 100%;
            align-items: center;
            justify-content: space-between;

            .demo-card-title {
                color: $color-primary-deep;
                padding-right: 12px;
            }

            .link-segment {
                flex: 1;
                background-color: $color-info;
            }
        }

        .demo-card-content {
            padding: 16px 0;

            & > *:not(.demo-row-item) {
                margin-right: 12px;
            }
        }
    }
</style>
